import React, { useState } from 'react'
import { object } from 'prop-types'
import { Link, graphql } from 'gatsby'
import styled from '@emotion/styled'

const Wrapper = styled.div`
	background: #241333;
	padding-top: 10px;
`

const Main = styled.main`
	padding: 20px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-evenly;

	* {
		box-sizing: border-box;
	}

	a {
		color: #fff;
	}
`

const SearchInput = styled.input`
	width: 50%;
	text-align: center;
	margin: 0 auto;
	display block;
	border-radius: 20px;
	border: 3px solid #c38bf5;
	background: #e1c0ff;

	&:focus {
		outline: none;
	}
`

const CatCard = styled.div`
	background: #8142bc;
	border: 3px solid #c38bf5;
	border-radius: 0px 20px;
	box-sizing: border-box;
	margin-bottom: 20px;
	padding: 20px;
	width: 100%;

	@media (min-width: 650px) {
		width: 48%;
	}

	@media (min-width: 900px) {
		width: 30%;
	}

	@media (min-width: 1200px) {
		width: 22%;
	}
`

const CatName = styled.div`
	color: #5b357d;
	font-size: 45px;
	font-weight: bolder;
	text-align: right;
	z-index: -1;
`

IndexPage.propTypes = {
	data: object,
}

function IndexPage({
	data: {
		allBzCategory: { edges },
	},
}) {
	const categories = edges.filter(({ node: { categoryId } }) => categoryId !== 999999).map(({ node }) => node)
	const [filteredCats, setFilteredCats] = useState(categories)

	const handleFilterCats = e => {
		const query = e.target.value

		const currentMatches = categories.filter(({ categoryName, categoryId }) => {
			return categoryName.toLowerCase().includes(query.toLowerCase()) || categoryId.toString().includes(query)
		})

		setFilteredCats(currentMatches)
	}

	return (
		<Wrapper>
			<SearchInput type="text" onChange={handleFilterCats} placeholder="search by categoryname or id" />
			<Main>
				{filteredCats.map(({ id, categoryId, categoryName, contentPath, layouts }) => {
					return (
						<CatCard key={`${id}card`}>
							{layouts.map(({ flowName }) => {
								const linkPath = `${contentPath}${flowName}/`
								const widgetLinkPath = `/${categoryId}/${flowName}/`

								return (
									<div key={`${id}${flowName}`}>
										{/* add on widget link via categoryId */}
										{flowName !== 'widget' ? (
											<Link to={linkPath}>
												<b>{flowName}</b> :: {linkPath}
											</Link>
										) : (
											<>
												<Link to={widgetLinkPath}>
													<b>{flowName}</b> :: {widgetLinkPath}
												</Link>
												<br />
												<Link to={`${widgetLinkPath}clementine/`}>
													<b>{flowName}</b> :: {`${widgetLinkPath}clementine/`}
												</Link>
												<br />
												<Link to={`${widgetLinkPath}neptune/`}>
													<b>{flowName}</b> :: {`${widgetLinkPath}neptune/`}
												</Link>
												<br />
												<Link to={`${widgetLinkPath}cosmo/`}>
													<b>{flowName}</b> :: {`${widgetLinkPath}cosmo/`}
												</Link>
												<br />
											</>
										)}
									</div>
								)
							})}

							<CatName>{categoryName}</CatName>
						</CatCard>
					)
				})}
			</Main>
		</Wrapper>
	)
}

export default IndexPage

export const pageQuery = graphql`
	query PageQuery {
		allBzCategory {
			edges {
				node {
					id
					categoryId
					categoryName
					contentPath
					layouts {
						flowName
						template
					}
				}
			}
		}
	}
`
